import type { HeadingBlock, LocaleCode } from '@fixit/bozp-content';
import { resolveLocalized } from '../locale';

export function HeadingBlockView({ block, locale }: { block: HeadingBlock; locale: LocaleCode }) {
  const text = resolveLocalized(block.text, locale);
  return block.level === 2 ? (
    <h2 data-block-type="heading">{text}</h2>
  ) : (
    <h3 data-block-type="heading">{text}</h3>
  );
}
